import { cx } from '@emotion/css';
import { Divider } from 'antd';
import { useChatHeaderOpen } from 'hooks/business/chat/useChatHeader';
import { ToolsBar } from 'views/Conversation/Chat/components/Head/components/ToolsBar';
import { HeaderStoreInfo } from './components/HeaderStoreInfo';
import { LightAdjustSalesStatus } from './components/AdjustSalesStatus';
import { DistributeIcon } from 'views/Conversation/Chat/components/DistributeDetail';

interface LightChatHeaderProps {
  className?: string;
  conversation: Conversation.Conversation;
}

export const LightChatHeader = (props: LightChatHeaderProps) => {
  const { className, conversation } = props;
  const { conversationId, buyerNick, channel, region, storeName, storeAlias, topBarInfo, storeId } =
    conversation;
  const { pauseAutoReplyEnable, starEnable, blacklistEnable, forwardEnable } =
    useChatHeaderOpen(conversation);

  return (
    <header
      className={cx('w-full flex items-center justify-between px-4 min-w-0 gap-3', className)}
    >
      <div className="flex items-center min-w-0 overflow-hidden">
        <div className="text-[#232426] font-medium max-w-[20%] truncate">{buyerNick}</div>
        <Divider type="vertical" />
        <HeaderStoreInfo
          storeId={storeId}
          channel={channel}
          region={region}
          storeName={storeName}
          storeAlias={storeAlias}
          storeType={topBarInfo?.storeType}
        />
        <Divider type="vertical" />
        <LightAdjustSalesStatus conversation={conversation} />
        <Divider type="vertical" />
        <span className="w-[20px] h-[20px] bg-[#FFFFFF] rounded-[2px] flex items-center justify-center border border-solid border-[#C9C9C9]">
          <DistributeIcon id={conversationId} className="!mt-0 !text-[16px] text-[#515359]" />
        </span>
      </div>
      <ToolsBar
        conversation={conversation}
        pauseAutoReplyEnable={pauseAutoReplyEnable}
        starEnable={starEnable}
        blacklistEnable={blacklistEnable}
        forwardEnable={forwardEnable}
      />
    </header>
  );
};
